import { ActivityCard } from '../../components/dashboard/ActivityCard';
import { EmptyState } from '../../components/ui/EmptyState';
import { MetricCard } from '../../components/ui/MetricCard';
import { MetricGrid } from '../../components/ui/MetricGrid';
import { PageHeader } from '../../components/ui/PageHeader';
import { SectionHeader } from '../../components/ui/SectionHeader';
import { activities } from '../../mock/bodyData';
import './TrainingPage.css';

const activityTypes = ['Strength', 'Weightlifting', 'CrossFit', 'Running', 'Cycling', 'Walking', 'Yoga', 'Other'];

export function TrainingPage() {
  return (
    <div className="page-stack">
      <PageHeader eyebrow="TRAINING" title="Training" subtitle="Activity history and workout architecture without a full editor yet." />

      <MetricGrid>
        <MetricCard label="This week" value="2 sessions" metadata="Mock activity summary" />
        <MetricCard label="Total time" value="63 min" metadata="Strength + walking" />
        <MetricCard label="Avg RPE" value="5.0" metadata="Recorded sessions only" />
        <MetricCard label="Primary focus" value="Upper" metadata="Rehab-aware placeholder" />
      </MetricGrid>

      <section>
        <SectionHeader title="Activity Types" />
        <div className="activity-type-grid">
          {activityTypes.map((type) => (
            <span key={type}>{type}</span>
          ))}
        </div>
      </section>

      <section>
        <SectionHeader title="Activity List" />
        <div className="activity-list">
          {activities.map((activity) => (
            <ActivityCard key={activity.id} activity={activity} />
          ))}
        </div>
      </section>

      <EmptyState
        title="Workout editor is intentionally not built in V0.1"
        description="The schema already supports Exercise and ExerciseSet for future strength and weightlifting logs."
      />
    </div>
  );
}
